import {Fragment, useEffect} from "react";
import {Link as RouterLink} from "react-router-dom";
import {
  Box,
  CloseButton,
  Dialog,
  Link,
  Portal,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import {ImBin} from "@onemind-services-llc/react-icons-ng/im";
import {useCalculator} from "../context/calculatorContext/context";
import SelectedListItem from "./SelectedListItem";
import ProductModalFooter from "./ProductModalFooter";
import WaitForPricingData from "./waitForPricingData";

const ProductModal = () => {
  const {showModal, selectedData, clearProductCart} = useCalculator();
  const {open, onOpen, onClose} = useDisclosure();

  useEffect(() => {
    if (showModal) onOpen();
    else onClose();
  }, [showModal, onOpen, onClose]);

  return (
    <Dialog.Root
      closeOnInteractOutside={false}
      open={open}
      onOpenChange={onClose}
      placement={"center"}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content
            w={{
              base: "calc(100vw - 50px)",
              sm: "calc(100vw - 50px)",
              md: "calc(100vw - 100px)",
            }}
            maxW={"1200px"}
          >
            <Dialog.CloseTrigger asChild>
              <CloseButton data-cy="product-modal-close-btn" size="sm" />
            </Dialog.CloseTrigger>
            <Box
              background={"#fafafa"}
              borderBottom={"1px solid #eaeded"}
              padding={"1rem"}
            >
              <Box display={"flex"} alignItems={"baseline"} gap={2}>
                <Text
                  color={"#111b27"}
                  fontSize={"18px"}
                  fontWeight={"500"}
                  data-cy="product-modal-heading"
                >
                  Hosted Emulator
                </Text>
                <Link as={RouterLink} onClick={onClose} to="/about">
                  <Text
                    display={{
                      base: "none",
                      sm: "none",
                      md: "block",
                    }}
                    fontSize={"12px"}
                    color={"#0073bb"}
                    cursor={"pointer"}
                    _hover={{textDecoration: "underline"}}
                  >
                    Info
                  </Text>
                </Link>
              </Box>
            </Box>
            <Box
              minH={"400px"}
              maxH="400px"
              overflow={"auto"}
              display={"grid"}
              gridTemplateColumns={"1fr"}
              gridGap={"0.5rem 0.8rem"}
              padding={"1rem 0.5rem 3rem 1rem"}
              borderBottom={"1px solid #eee"}
            >
              {selectedData.length > 0 ? (
                selectedData.map((item) => {
                  return <SelectedListItem key={item.id} {...item} />;
                })
              ) : (
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  flexDir={"column"}
                  gridArea={"1 / 1 / 4 / 4"}
                >
                  <Text>Select Some Virtual Machine</Text>
                  <Text
                    fontSize={"16px"}
                    color={"#0073bb"}
                    cursor={"pointer"}
                    _hover={{textDecoration: "underline"}}
                    onClick={() => {
                      onClose();
                      window.location.href = "/vendor/all-vendor";
                    }}
                    data-cy="see-all-vendor-link"
                  >
                    See All Vendor
                  </Text>
                </Box>
              )}
            </Box>

            {selectedData.length > 0 && (
              <Fragment>
                <Box p={4} pb={0}>
                  <Text
                    display={"inline-flex"}
                    cursor={"pointer"}
                    alignItems={"flex-start"}
                    color={"#1a5f7a"}
                    fontWeight={"600"}
                    fontSize={"15px"}
                    onClick={clearProductCart}
                    data-cy="clear-cart"
                  >
                    <ImBin
                      style={{
                        fontSize: "17px",
                      }}
                    />
                    Clear Cart
                  </Text>
                </Box>
                <WaitForPricingData>
                  <ProductModalFooter onClose={onClose} />
                </WaitForPricingData>
              </Fragment>
            )}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ProductModal;
